const solution_CN_Locale = {
    'solution.pair': 'Pair丨一站式医学影像专用标注软件',
    'solution.pairContnt': '国内首款一站式医学影像智能标注软件，专业便捷、高度智能化，高效助力科研。',
    'solution.cupid': 'CUPID丨产前智能超声筛查系统',
    'solution.cupidContent': '产科超声检查全孕周覆盖、实时引导、智能分析，用 AI 共同守护新生。',
    'solution.AutoPelvic': 'AutoPelvic丨盆底智能超声筛查系统',
    'solution.AutoPelvicContent': '为成年女性盆底超声检查提供自动识别、精准测量、智能分析，智敬天下女性。',
    'solution.AutoDDH': 'AutoDDH丨婴幼儿髋关节智能超声影像处理系统',
    'solution.AutoDDHContent': '适用于婴幼儿髋关节发育不良超声筛查，动态识别、精确计算，是医生的得力助手。',
    'solution.AutoBreast': 'AutoBreast丨乳腺超声辅助筛查系统',
    'solution.AutoBreastContent': '适用于女性乳腺结节超声检查，实现病灶动态识别、实时分析，关键帧自动获取，火眼金睛、无结可藏。',
    'solution.AutoThyroid': 'AutoThyroid丨甲状腺超声辅助筛查评估系统',
    'solution.AutoThyroidContent': '适用于甲状腺病灶超声筛查，实现病灶动态定位、智能评估特征，提高筛查时效，助力基层筛查。',
    'solution.AutoCardiac': 'AutoCardiac丨心脏超声智能辅助筛查系统',
    'solution.AutoCardiacContent': '适用于成人心脏超声心动图检查，提供全心智能分析和超精度识别测量，不止“心动”，AI拥抱爱。',
    'solution.AutoFollicle': 'AutoFollicle丨辅助生殖自动测量系统',
    'solution.AutoFollicleContent': '适用于临床辅助生殖下超声卵泡监测，提供卵泡自动测量及子宫内膜容受性分析，智慧孕育、助力未来。',
    'solution.ATLAS': 'ATLAS丨智能超声质控平台',
    'solution.ATLASContent': '适用于超声质控，大批量智能质控、毫秒级别反馈、标准量化评分、一键质控报告，为全方位服务质控工作。',
    'solution.scheme': '通用AI解决方案：',
    'solution.schemeContent': '支持2D静态、2D动态、3D、4D等模态数据的各项超声检查的AI分析',
    'solution.compatible': '兼容性强：',
    'solution.compatibleContent': '支持所有超声设备的各种操作系统（Windows XP/7/8/10 32位/64位、Linux和Android等）',
    'solution.devise': '轻量级设计：',
    'solution.deviseContent': '轻依赖性设计，以满足多种复杂集成要求',
    'solution.performance': '卓越性能：',
    'solution.performanceContent': '在计算成本和推理效率方面优于NVIDIA的 TensorRT 和Intel的 OpenVINO',
    'solution.productDetails': '了解产品详情',
    'solution.seeMore': '查看更多',
    'solution.niceTitle': '超声设备通用智能推理引擎',
    'solution.niceContent': '团队拥有完全自主知识产权的超声设备通用智能推理引擎NiCE，是智能超声领域首个国产自研深度学习推理框架。NiCE超声扩展至低算力环境，实现高精度、高效率和低资源占用的部署，快捷升级高端智能超声功能，有效促进智能超声在全国的推广，提升基层机构的智能诊疗服务。',
    'solution.advantagesTitle': '集成优势',
    'solution.userTitle': '用户价值',
    'solution.userValueTitle1': '硬件成本更低',
    'solution.userValueContent1': 'AI应用不依赖昂贵硬件',
    'solution.userValueTitle2': '图像质量更好',
    'solution.userValueContent2': 'AI应用不影响机器本身成像',
    'solution.userValueTitle3': '产品迭代更快',
    'solution.userValueContent3': '高性价比AI应用标准化快速集成',
}
export default solution_CN_Locale
